import { AxiosService } from './axiosService';

export class DashboardService extends AxiosService {
    
    async getDashboard(startDate, endDate) {
        try {
            const { data } = await this.axios.get(`/proposals/dashboard`, {
                params: {
                    startDate: startDate,
                    endDate: endDate
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

}

export const dashboardService = new DashboardService();
